<template>
    <div class="console-body-content-item console-video-hotspots">
        <div class="console-body-content-item-title">
            <span>Hotspots</span>
        </div>
        <div class="console-body-line">
            <ol class="d-flex flex-row justify-content-start align-self-start flex-wrap"  style="list-style-type: none">
                <li class="console-hotspot-item"
                    v-for="(hotspot, index) in getHotspots"
                    :key="index" style="width: 20%;">
                    <div class="d-flex flex-column">
                        <div class="console-body-line">
                            <span>Hotspot ID: </span><span class="console-body-text">{{ hotspot.hotspotId }}</span>
                        </div>
                        <div class="console-body-line">
                            <span>Name: </span><span class="console-body-text">{{ hotspot.title }}</span>
                        </div>
                        <div class="console-body-line">
                            <span>Type: </span><span class="console-body-text">{{ hotspot.hotspotType.description }}</span>
                        </div>
                        <div class="console-body-line">
                            <span>Action Type: </span><span class="console-body-text">{{ hotspot.hotspotAction.actionType.description }}</span>
                        </div>
                        <div class="console-body-line"
                             v-if="hotspot.hotspotAction.actionType.actionTypeId === 2 || hotspot.hotspotAction.actionType.actionTypeId === 3">
                            <span>Action: </span>
                            <span class="console-body-text" v-if="hotspot.hotspotAction.actionType.actionTypeId === 2">
                                <a target="_blank" :href="hotspot.hotspotAction.parameter" class="console-body-text">Link</a>
                            </span>
                            <span class="console-body-text" v-if="hotspot.hotspotAction.actionType.actionTypeId === 3">{{ hotspot.hotspotAction.parameterDecimal }} sec</span>
                        </div>
                        <div class="console-body-line">
                            <span>Start: </span><span class="console-body-text">{{ hotspot.timeStart }} sec</span>
                        </div>
                        <div class="console-body-line">
                            <span>End: </span><span class="console-body-text">{{ hotspot.timeEnd }} sec</span>
                        </div>
                        <div class="console-body-line">
                            <span>Duration: </span><span class="console-body-text">{{ hotspot.timeDuration.toFixed(4) }} sec</span>
                        </div>
                        <div class="console-body-line">
                            <span>Status: </span>
                            <span class="console-body-text"
                            :class="[hotspot.visible === true ? 'console-body-text-active' : 'console-body-text']">{{ hotspot.visible }}</span>
                        </div>
                        <div class="console-body-line">
                            <span>Interacted: </span>
                            <span :class="[hotspot.interacted === true ? 'console-body-text-active' : 'console-body-text']">{{ hotspot.interacted }}</span>
                        </div>
                    </div>
                </li>
            </ol>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getHotspots = computed(() => {
    return store.getHotspotsData;
});

// METHODS

// LIFECYCLE HOOKS
</script>
